/**
 * Il mezzo che una persona si porta dietro.
 *
 * Sulla scheda di un'autovettura o di un furgone attrezzato c'è
 * l'«utilizzatore»: il dipendente a cui la macchina è affidata, lo stesso che
 * si vede sulla localizzazione. Se quella persona va in cantiere, quel mezzo
 * ci va con lei: spuntarli tutte e due a mano era un passaggio in più che
 * qualche volta si dimenticava, e la giornata risultava senza mezzo.
 *
 * Resta tutto modificabile: il mezzo si toglie con la sua spunta come prima,
 * perché può essere in officina o servire a un altro.
 */

/** Un mezzo si può portare in cantiere se non è fermo né dismesso. */
const disponibile = (m) => !["maintenance", "dismessa", "dismissed", "stolen", "scrapped", "sold"]
  .includes(String(m?.status || "").toLowerCase());

/** I mezzi affidati a questa persona, divisi fra quelli buoni e quelli fermi. */
export function mezziDellaPersona(empId, equipment) {
  const suoi = (equipment || []).filter((m) => m.utilizzatore_id && m.utilizzatore_id === empId);
  return {
    liberi: suoi.filter(disponibile).map((m) => m.id),
    fermi: suoi.filter((m) => !disponibile(m)),
  };
}

/** «FM904FY · Sprinter», come si legge sulla pastiglia del mezzo. */
export function etichettaMezzo(m) {
  if (!m) return "";
  return [m.identifier, m.model || m.tipo || m.brand].filter(Boolean).join(" · ");
}

/**
 * Lo stato dei mezzi dopo che si è spuntata o tolta una persona.
 *
 * `auto` tiene i mezzi arrivati per via dell'affidamento: solo quelli se ne
 * vanno quando si toglie la persona, così un mezzo aggiunto a mano resta
 * dov'è. E non si toglie niente che serva a un altro ancora in squadra.
 */
export function dopoLaPersona({ id, entra, personeDopo, mezzi, auto, equipment }) {
  const { liberi, fermi } = mezziDellaPersona(id, equipment);

  if (entra) {
    const nuovi = liberi.filter((m) => !mezzi.includes(m));
    return {
      mezzi: [...mezzi, ...nuovi],
      auto: [...new Set([...(auto || []), ...nuovi])],
      aggiunti: nuovi,
      fermi,
    };
  }

  const diAltri = new Set(
    (personeDopo || []).flatMap((p) => mezziDellaPersona(p, equipment).liberi));
  const daTogliere = liberi.filter(
    (m) => (auto || []).includes(m) && !diAltri.has(m));
  return {
    mezzi: mezzi.filter((m) => !daTogliere.includes(m)),
    auto: (auto || []).filter((m) => !daTogliere.includes(m)),
    tolti: daTogliere,
    fermi: [],
  };
}
